import React, { useEffect, useState } from 'react';
import './NewPocForm.scss';
import { NewClientPayloadSchema } from '../../../redux/oms/omsTypes';
import { toast } from 'react-toastify';
import { toastOptions } from '../../../utils/toast';

interface NewCompanyFormProps {
  editing: boolean;
  onCancel: () => void;
  onAddNewPoc: (payload: {
    name: string;
    designation: string;
    phone_number: string;
    email: string;
    id: number;
  }) => void;
  pocDetails?: {
    poc_name: string;
    designation: string;
    phone_number: string;
    email: string;
  };
}

const initContactDetail = {
  name: '',
  designation: '',
  phone_number: '',
  email: '',
  id: -1,
};

const NewPocForm: React.FC<NewCompanyFormProps> = ({
  editing,
  onCancel,
  onAddNewPoc,
  pocDetails,
}) => {
  const [contactDetails, setContactDetails] = useState(initContactDetail);

  useEffect(() => {
    if (pocDetails) {
      setContactDetails({
        name: pocDetails.poc_name,
        designation: pocDetails.designation,
        phone_number: pocDetails.phone_number,
        email: pocDetails.email,
        id: -1,
      });
    }
  }, []);

  const onAddClientHandler = () => {
    // const allFieldsFilled = Object.values(contactDetails).every(
    //   (value) => value.trim().length > 0
    // );

    // if (!allFieldsFilled) {
    //   toast.error('All fields are compulsory', toastOptions);
    //   return;
    // }
    onAddNewPoc(contactDetails);
  };

  const updateFormDetail = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    setContactDetails((prev) => ({
      ...prev,
      [key]: event.target.value,
    }));
  };

  return (
    <div className="px-12 py-16 new-poc-form-container flex-column gap-24">
      <p className="title xetgo-font-button-bold">
        {editing ? 'Edit POC Information' : 'Add New POC'}
      </p>
      <div className="new-client-form flex-column gap-12">
        <div className="company-details flex-row gap-12">
          <div className="new-client-entry flex-column gap-8">
            <p className="label xetgo-font-tag"> Name</p>
            <input
              className="new-client-form-input xetgo-font-tag"
              placeholder="Enter POC Name"
              value={contactDetails.name}
              onChange={(e) => updateFormDetail(e, 'name')}
            />
          </div>

          <div className="new-client-entry flex-column gap-8">
            <p className="label xetgo-font-tag">Email</p>
            <input
              className="new-client-form-input xetgo-font-tag"
              placeholder="example@gmail.com"
              value={contactDetails.email}
              onChange={(e) => updateFormDetail(e, 'email')}
            />
          </div>
        </div>

        <div className="new-client-details-container">
          <div className="new-client-entry flex-column gap-8">
            <p className="label xetgo-font-tag">Phone Number</p>
            <input
              className="new-client-form-input xetgo-font-tag"
              placeholder="Enter POC Contact No."
              value={contactDetails.phone_number}
              onChange={(e) => updateFormDetail(e, 'phone_number')}
            />
          </div>
          <div className="new-client-entry flex-column gap-8">
            <p className="label xetgo-font-tag">Designation</p>
            <input
              className="new-client-form-input xetgo-font-tag"
              placeholder="Enter POC Designation"
              value={contactDetails.designation}
              onChange={(e) => updateFormDetail(e, 'designation')}
            />
          </div>
        </div>
      </div>
      <div className="flex-row gap-12 new-form-btn-container">
        <div className="cancel-btn xetgo-font-tag" onClick={onCancel}>
          Cancel
        </div>
        <div className="add-btn xetgo-font-tag" onClick={onAddClientHandler}>
          Save
        </div>
      </div>
    </div>
  );
};

export default NewPocForm;
